/* eslint-disable quotes */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import advSearchState from 'Stores/advSearch';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { observer } from 'mobx-react';
// import { makeApi, URLS } from 'Utils/apiUtil';
import Dropdown from 'Components/common/dropdown';
import { ReactComponent as RadioInnerIcon } from '../../../../assets/svg/radio-inner-icon.svg';
import { ReactComponent as RadioOuterIcon } from '../../../../assets/svg/radio-outer-icon.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-icon.svg';
import { ReactComponent as DownArrowIcon } from '../../../../assets/svg/down-arrow-icon.svg';

const LocationPreference = observer(props => {
  const { filterInPage = false } = props;
  const [showSuggestion] = React.useState(false);

  let locationPreferences;
  let preferenceTitle;
  if (filterInPage) {
    locationPreferences = advSearchState.locationPreferences;
    preferenceTitle = 'Preferences';
  } else {
    locationPreferences = advSearchFilterPopupState.locationPreferences;
    preferenceTitle = 'Location Preference';
  }

  const onInputChange = (e, val) => {
    if (filterInPage) advSearchState.setLocationPreferences(val);
    else advSearchFilterPopupState.setLocationPreferences(val);
  };

  return (
    <div className="dropdown-section location-preference">
      <Dropdown
        className={`${
          filterInPage ? '' : 'suggestion-list'
        } radio-btn-wrap location-options`}
        toggleElement={
          <div className="location-preference-header">
            {preferenceTitle}
            <DownArrowIcon
              className="dropdown-icon plus-icon"
              width={14}
              height={14}
            />
          </div>
        }
      >
        <div className="radio-wrapper">
          <div
            className={`radio-item${
              locationPreferences === 'company' ? ' selected' : ''
            }`}
            onClick={e => onInputChange(e, 'company')}
          >
            <div className="radio-svg-section">
              <RadioInnerIcon className="radio-inner" viewBox="0 0 24 24" />
              <RadioOuterIcon className="radio-outer" viewBox="0 0 24 24" />
            </div>
            <div className="radio-text">{"Company's HQ location"}</div>
          </div>
          <div
            className={`radio-item${
              locationPreferences === 'contact' ? ' selected' : ''
            }`}
            onClick={e => onInputChange(e, 'contact')}
          >
            <div className="radio-svg-section">
              <RadioInnerIcon className="radio-inner" viewBox="0 0 24 24" />
              <RadioOuterIcon className="radio-outer" viewBox="0 0 24 24" />
            </div>
            <div className="radio-text">{"Contact's location"}</div>
          </div>
          <div
            className={`radio-item${
              locationPreferences === '*' ? ' selected' : ''
            }`}
            onClick={e => onInputChange(e, '*')}
          >
            <div className="radio-svg-section">
              <RadioInnerIcon className="radio-inner" viewBox="0 0 24 24" />
              <RadioOuterIcon className="radio-outer" viewBox="0 0 24 24" />
            </div>
            <div className="radio-text">
              {"Contact's OR Company's HQ location"}
            </div>
          </div>
          <div
            className={`radio-item${
              locationPreferences === 'AND' ? ' selected' : ''
            }`}
            onClick={e => onInputChange(e, 'AND')}
          >
            <div className="radio-svg-section">
              <RadioInnerIcon className="radio-inner" viewBox="0 0 24 24" />
              <RadioOuterIcon className="radio-outer" viewBox="0 0 24 24" />
            </div>
            <div className="radio-text">
              {"Contact's AND Company's HQ location"}
            </div>
          </div>
        </div>
      </Dropdown>
    </div>
  );
});

export { LocationPreference };
export default LocationPreference;
